import { router } from "@/router";
import { Resource } from "@/types";
import { createResource } from "frappe-ui";
import { clear } from "idb-keyval";
import { computed, reactive } from "vue";

export const session = reactive({
  login: createResource({
    url: "login",
    makeParams({ email, password }) {
      return {
        usr: email,
        pwd: password
      };
    }
  }),
  logout: createResource({
    url: "logout",
    async onSuccess() {
      session.user = getSessionUser();
      clear(); // clear all cache from the session
      await router.replace({ name: "Login" });
    }
  }),
  user: getSessionUser(),
  isLoggedIn: computed(() => !!session.user),
  isSystemUser: getSessionCookies().get("system_user") === "yes",
});

function getSessionUser() {
  let cookies = getSessionCookies();
  let sessionUser = cookies.get("user_id");
  if (!sessionUser || sessionUser === "Guest") {
    sessionUser = null;
  }
  return sessionUser;
}

function getSessionCookies() {
  return new URLSearchParams(document.cookie.split("; ").join("&"));
}

const _user_info: Resource<any> = createResource({
  cache: "bookings.ui.api_handlers.user.get_user_info",
  url: "bookings.ui.api_handlers.user.get_user_info",
})


export function getSessionUserInfo() {
  _user_info.reload()
  return _user_info
}

export function isGuest() {
  return !session.user
}
